import keyMirror from 'keymirror-nested'

export default keyMirror({
  COMPANY_INFO: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
